module.exports = __webpack_public_path__ + "static/media/picklerick.b9522120.png";